// extracted by mini-css-extract-plugin
export default {"container":"not-allowed-screen_container__mOZqS","card":"not-allowed-screen_card__YWGWK","text":"not-allowed-screen_text__e4caw"};